import React, { useState, useEffect, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Dropdown,
  Icon,
  Loader,
  Modal,
  Input as SemanticInput,
  Button,
} from "semantic-ui-react";
import {
  ContainerInputSearch,
  Input,
  SemanticTable,
  StyledLabel,
  StyledButton,
  Buttons,
} from "./styles";
import { systemLogs } from "../../../../services/system_logs";
import { useRouter } from "../../../../hooks/router";

const Formulario = () => {
  const [indicacoesFiltradas, setIndicacoesFiltradas] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [parceiro, setParceiro] = useState(null);
  const [search, setSearch] = useState("");
  const [evento, setEvento] = useState(null);
  const [ordenacao, setOrdenacao] = useState("desc");
  const [opcoesEventos, setOpcoesEventos] = useState([]);
  const [modalEditarOpen, setModalEditarOpen] = useState(false);
  const [indicacaoEditando, setIndicacaoEditando] = useState(null);
  const [novoId, setNovoId] = useState("");
  const [novoCodigoCupom, setNovoCodigoCupom] = useState("");
  const [loading, setLoading] = useState(false);

  const bottom = useRef(null);
  const [reachedEnd, setReachedEnd] = useState(false);
  const router = useRouter();

  useEffect(() => {
    api.get("eventos").then((res) => {
      const newEventos = res.data.map((evento) => ({
        key: evento.id,
        text: evento.titulo,
        value: evento.id,
      }));

      setOpcoesEventos(newEventos);
    });
  }, []);

  const formatarData = (dataString) => {
    if (!dataString) return "";

    try {
      const data = new Date(dataString);
      const dia = data.getDate().toString().padStart(2, "0");
      const mes = (data.getMonth() + 1).toString().padStart(2, "0");
      const ano = data.getFullYear();

      return `${dia}/${mes}/${ano}`;
    } catch (error) {
      console.error("Erro ao formatar data:", error);
      return dataString;
    }
  };

  const copiarLinkIndicacao = useCallback((indicacao) => {
    if (!indicacao) return;

    const isEventoEspecial = indicacao?.id_evento === 15 || indicacao?.id_evento === 16;
    const linkIndicacao = isEventoEspecial
      ? `https://voitto.com.br/evento/${indicacao?.evento?.url_evento}?token=${indicacao.id}`
      : `https://voitto.com.br/${indicacao?.evento?.url_evento}?token=${indicacao.id}`;

    navigator.clipboard
      .writeText(linkIndicacao)
      .then(() => {
        toast.success(
          "Link de indicação copiado para a área de transferência!",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      })
      .catch((err) => {
        console.error("Erro ao copiar link:", err);
        toast.error("Erro ao copiar link de indicação", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  }, []);

  const abrirModalEdicao = useCallback((indicacao) => {
    setIndicacaoEditando(indicacao);
    setNovoId(indicacao.id);
    setNovoCodigoCupom(indicacao.codigo_cupom || "");
    setModalEditarOpen(true);
  }, []);

  const fecharModalEdicao = useCallback(() => {
    setModalEditarOpen(false);
    setIndicacaoEditando(null);
    setNovoId("");
    setNovoCodigoCupom("");
  }, []);

  const salvarEdicaoId = useCallback(async () => {
    try {
      if (!novoId.trim()) {
        toast.error("O ID não pode estar vazio", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }

      await api.put(`/inscricoes-eventos-new/${indicacaoEditando.id}`, {
        new_id: novoId.trim(),
        codigo_cupom: novoCodigoCupom.trim(),
      });

      await listarIndicacoes({ page: 1 });

      setPage(1);
      setReachedEnd(false);

      toast.success("Indicação atualizada com sucesso!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      fecharModalEdicao();
    } catch (err) {
      console.error("Erro ao atualizar indicação:", err);
      const mensagem =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Erro ao atualizar. Tente novamente.";
      toast.error(mensagem, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [novoId, novoCodigoCupom, indicacaoEditando, fecharModalEdicao]);

  const listarIndicacoes = useCallback(
    async (filters) => {
      setLoading(true);
      try {
        const params = {
          page: filters.page !== undefined ? filters.page : 1,
          parceiro:
            filters.parceiro !== undefined ? filters.parceiro : parceiro,
          search: filters.search !== undefined ? filters.search : search,
          event: filters.event !== undefined ? filters.event : evento,
          ordenacao:
            filters.ordenacao !== undefined ? filters.ordenacao : ordenacao,
        };

        const data = (
          await api
            .get("inscricoes-eventos-new", {
              params,
            })
            .catch(() => null)
        )?.data;

        const { items, pages } = data || { items: [], pages: 0 };

        if (!data || !items?.length) {
          setReachedEnd(true);
        }

        await systemLogs("eventos", "listou as indicações de eventos");

        setTotalPage(pages);

        if (params.page === 1) {
          setIndicacoesFiltradas(items);
        } else {
          setIndicacoesFiltradas(items); // Substitui os itens ao invés de adicionar
        }
      } catch (err) {
        if (err) {
          toast.error(
            "Seu login expirou, por gentileza, realize o mesmo novamente",
            {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      } finally {
        setLoading(false);
      }
    },
    [parceiro, evento, search, ordenacao]
  );

  const nextPage = useCallback(async () => {
    if (page < totalPage) {
      const pageNumber = page + 1;
      await listarIndicacoes({ page: pageNumber });
      setPage(pageNumber);
      window.scrollTo(0, 0); // Rola para o topo
    }
  }, [page, totalPage, listarIndicacoes]);

  const previousPage = useCallback(async () => {
    if (page > 1) {
      const pageNumber = page - 1;
      await listarIndicacoes({ page: pageNumber });
      setPage(pageNumber);
      window.scrollTo(0, 0); // Rola para o topo
    }
  }, [page, listarIndicacoes]);

  const handleParceriaChange = useCallback(
    (e, { options, value }) => {
      setPage(1); // Reseta a página para 1
      setParceiro(value);
      listarIndicacoes({ parceiro: value, page: 1 }); // Limpa a paginação
    },
    [listarIndicacoes]
  );

  const cleanSearch = () => {
    const filters = {
      search: "",
      ordenacao: "asc",
      page: 1,
      parceiro: null,
    };

    setSearch(filters.search);
    setOrdenacao(filters.ordenacao);
    setPage(filters.page);
    setParceiro(filters.parceiro);

    listarIndicacoes(filters);
  };

  const handleEventoChange = useCallback((e, { value }) => {
    setPage(1); // Reseta a página para 1
    setParceiro(null);
    setEvento(value);
    listarIndicacoes({ event: value, page: 1 }); // Limpa a paginação
  }, []);

  useEffect(() => {
    const { id_evento } = router.query;

    const event = Number(id_evento || "0");

    setEvento(event);

    listarIndicacoes({ event });
  }, [router]);

  const handleOrdenacao = useCallback(
    (ordenacao) => {
      setPage(1); // Reseta a página para 1
      setOrdenacao(ordenacao);
      listarIndicacoes({ ordenacao, page: 1 }); // Limpa a paginação
    },
    [evento, parceiro, search]
  );

  return (
    <>
      <StyledButton
        onClick={() => window.open("/admin/inscricoes-eventos/criar")}
        color={"#1f75cb"}
        margin="0 0 32px 0"
      >
        <i className="plus icon" />
        Cadastrar Participante(s)
      </StyledButton>

      <StyledLabel>Evento</StyledLabel>
      <Dropdown
        fluid
        selection
        options={opcoesEventos}
        onChange={handleEventoChange}
        value={evento}
      />
      <StyledLabel>Filtrar por nome</StyledLabel>
      <ContainerInputSearch className="ui fluid left icon input">
        <Input
          type="search"
          placeholder="Pesquisar indicação"
          onKeyPress={(e) =>
            e.key === "Enter" && listarIndicacoes({ search: e.target.value, page: 1 })
          }
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Icon name="search icon" />

        <StyledButton onClick={cleanSearch}>Limpar busca</StyledButton>
      </ContainerInputSearch>

      <StyledLabel>Ordenar por:</StyledLabel>
      <Buttons>
        <StyledButton
          onClick={() => handleOrdenacao("desc")}
          color={ordenacao === "desc" ? "green" : "black"}
        >
          <i className="plus icon" />
          Decrescente
        </StyledButton>
        <StyledButton
          onClick={() => handleOrdenacao("asc")}
          color={ordenacao === "asc" ? "green" : "black"}
        >
          <i className="minus icon" />
          Crescente
        </StyledButton>
      </Buttons>

      <SemanticTable size="small" celled>
        <SemanticTable.Header>
          <SemanticTable.Row>
            <SemanticTable.HeaderCell>ID</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Evento inscrito</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>
              Data de cadastro
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell>Indicações</SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell style={{ minWidth: "180px" }}>
              Ações
            </SemanticTable.HeaderCell>
          </SemanticTable.Row>
        </SemanticTable.Header>

        <SemanticTable.Body>
          {indicacoesFiltradas.map((indicacao) => (
            <SemanticTable.Row key={indicacao.id}>
              <SemanticTable.Cell>{indicacao.id}</SemanticTable.Cell>
              <SemanticTable.Cell>{indicacao.nome}</SemanticTable.Cell>
              <SemanticTable.Cell>{indicacao.email}</SemanticTable.Cell>
              <SemanticTable.Cell>{indicacao.id_evento}</SemanticTable.Cell>
              <SemanticTable.Cell>
                {formatarData(indicacao.data_cadastro)}
              </SemanticTable.Cell>
              <SemanticTable.Cell>{indicacao.indicacoes}</SemanticTable.Cell>
              <SemanticTable.Cell>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                  }}
                >
                  <StyledButton
                    title="Ver dados do cadastro no evento"
                    onClick={() =>
                      window.open(
                        `/admin/inscricoes-eventos/perfil/${indicacao.id}`
                      )
                    }
                    style={{
                      minWidth: "50px",
                      fontSize: "12px",
                      padding: "6px 8px",
                    }}
                  >
                    Perfil
                  </StyledButton>
                  <StyledButton
                    title="Copiar link de indicação"
                    onClick={() => copiarLinkIndicacao(indicacao)}
                    style={{
                      minWidth: "35px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="copy" style={{ margin: "0" }} />
                  </StyledButton>
                  <StyledButton
                    title="Editar ID"
                    onClick={() => abrirModalEdicao(indicacao)}
                    style={{
                      minWidth: "35px",
                      padding: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="edit" style={{ margin: "0" }} />
                  </StyledButton>
                </div>
              </SemanticTable.Cell>
            </SemanticTable.Row>
          ))}
        </SemanticTable.Body>
      </SemanticTable>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <Button onClick={previousPage} disabled={page === 1} color="#e0e1e2">
          Anterior
        </Button>
        <span>
          Página {page} de {totalPage}
        </span>
        <Button onClick={nextPage} disabled={page === totalPage} color="#e0e1e2">
          Próxima
        </Button>
      </div>

      <div ref={bottom}>
        {loading ? <Loader active inline="centered" size="massive" /> : null}
      </div>

      <Modal
        open={modalEditarOpen}
        onClose={() => {}}
        size="small"
        closeIcon={{
          style: { top: "1rem", right: "1rem" },
          name: "close",
          onClick: fecharModalEdicao,
        }}
      >
        <Modal.Header>Editar Indicação</Modal.Header>
        <Modal.Content>
          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              ID atual: {indicacaoEditando?.id}
            </label>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Novo ID:
            </label>
            <SemanticInput
              fluid
              value={novoId}
              onChange={(e) => setNovoId(e.target.value)}
              placeholder="Digite o novo ID"
              autoFocus
            />
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Cupom personalizado (opcional):
            </label>
            <SemanticInput
              fluid
              value={novoCodigoCupom}
              onChange={(e) => setNovoCodigoCupom(e.target.value)}
              placeholder="Ex: PARCERIAXTUDO90 (deixe vazio pra usar cupom default da landing)"
            />
            <small
              style={{ display: "block", marginTop: "0.4rem", color: "#666" }}
            >
              Quando preenchido, leads que chegarem por esse link de indicação
              recebem esse cupom automaticamente. Vazio = usa o cupom padrão
              do lançamento.
            </small>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color="grey" onClick={fecharModalEdicao}>
            Cancelar
          </Button>
          <Button color="green" onClick={salvarEdicaoId}>
            <Icon name="save" />
            Salvar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default Formulario;